/* globals $, Snap */
import { TweenMax, Bounce } from 'gsap';
import 'gsap/ScrollToPlugin';
import 'gsap/CSSPlugin';

const nationalParkIconAnim = function (iconTimeline) {
  let np = $('#icon-nationalpark');
  np.attr({
    viewBox: '0 0 600 600',
  });
  $('#stat-nationalpark').addClass('svg');
  let l = $('#logo');
  l.attr({
    fill: '#ffffff',
  });

  iconTimeline.add(TweenMax.from($('#map'), .2, {
    fillOpacity: 0,
  }), '=-0.5');

  iconTimeline.add(TweenMax.fromTo($('#plant'), .2, {
    yPercent: 150,
    scale: 0.5,
  }, {
    yPercent: 2,
    scale: 1,
  }));

  iconTimeline.add(TweenMax.from($('#logo'), .2, {
    fillOpacity: 0,
  }));

  iconTimeline.add(TweenMax.from('#stat-nationalpark p', 0.2, {
    yPercent: 100,
    autoAlpha: 0,
  }), '=-0.5');
};

const diverseIconAnim = function (iconTimeline) {
  let dv = Snap('#icon-diverse');
  dv.attr({ viewBox: '0 0 600 600' });
  $('#stat-diverse').addClass('svg');

  let c1 = dv.circle('50%', '50%', '250');
  c1.attr({
    id: 'diversity-bg',
    stroke: '#212121',
    strokeWidth: 100,
  });

  let c2 = dv.circle('50%', '50%', '250');
  c2.attr({
    id: 'diversity',
    stroke: '#fae71f',
    strokeWidth: 100,
    fill: 'none',
  });

  let text = dv.text('50%', '50%', '44%');
  text.attr({
    'id': 'count',
    'font-size': 120,
    'font-family': 'open-sans, Helvetica, Arial',
    'font-weight': 800,
    'font-style': 'normal',
    'fill': '#FFFFFF',
    'text-anchor': 'middle',
    'alignment-baseline': 'central',
  });

  let count = {
    var: 0,
  };

  iconTimeline.add(TweenMax.from($('circle#diversity-bg'), .2, {
    drawSVG: '0',
  }), '=-0.5');

  iconTimeline.add(TweenMax.from($('#count'), .2, {
    fillOpacity: 0,
  }), '=-.2');

  iconTimeline.add(TweenMax.to(count, .5, {
    var: 44,
    onUpdate: () => {
      text.attr({
        text: String(Math.ceil(count.var) + '%'),
      });
    },
  }));

  iconTimeline.add(TweenMax.fromTo($('circle#diversity'), 0.5, {
    css: {'stroke-dashoffset': '-544%', 'stroke-dasharray': '272%'},
    autoAlpha: 0,
  }, {
    css: {'stroke-dashoffset': '-544%', 'stroke-dasharray': '116%'},
    autoAlpha: 1,
  }), '=-1');

  iconTimeline.add(TweenMax.from('#stat-diverse p', 0.2, {
    yPercent: 100,
    autoAlpha: 0,
  }), '=-0.5');
};

const locationIconAnim = function (iconTimeline) {
  let pl = Snap('#icon-location');
  pl.attr({
    viewBox: '0 0 600 600',
  });
  $('#stat-location').addClass('svg');

  iconTimeline.add(TweenMax.from('#m1', .2, {
    fillOpacity: 0.6,
    y: '+400',
    ease: Bounce.easeOut,
  }), '=-1');

  iconTimeline.add(TweenMax.from('#m2', .2, {
    fillOpacity: 0.6,
    y: '+400',
    ease: Bounce.easeOut,
  }), '=-.8');

  iconTimeline.add(TweenMax.from('#m3', .2, {
    fillOpacity: 0.6,
    y: '+400',
    ease: Bounce.easeOut,
  }), '=-.2');

  iconTimeline.add(TweenMax.from('#stat-location p', 0.2, {
    yPercent: 100,
    autoAlpha: 0,
  }), '=-0.2');
};

const populationIconAnim = function (iconTimeline) {
  let p = $('#icon-population');
  p.attr({
    viewBox: '0 0 600 600',
  });
  $('#stat-population').addClass('svg');

  iconTimeline.add(TweenMax.staggerFrom(['#p1', '#p2', '#p3', '#p4', '#p5', '#p6', '#p7', '#p8', '#p9'], 0.2, {
    fillOpacity: 0,
  }, 0.1));
  iconTimeline.add(TweenMax.from('#stat-population p', 0.2, {
    yPercent: 100,
    autoAlpha: 0,
  }), '=-0.5');
};

export default function statsScene (iconTimeline) {
  populationIconAnim(iconTimeline);
  locationIconAnim(iconTimeline);
  diverseIconAnim(iconTimeline);
  nationalParkIconAnim(iconTimeline);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/statsScene.js